import { useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createUserMessage } from '../../../../../utils/helpers';
import AppContext from '../../../AppContext';
import { Button } from 'antd';
import {
  addMessage,
  disableButtons,
  fetchBotResponse,
  toggleBotTyping,
  toggleUserTyping
} from '../messageSlice';
import { formattedTs } from '../utils';

export const Buttons = ({ buttons, index, showBotAvatar, ts, callback }) => {
  const dispatch = useDispatch();
  const appContext = useContext(AppContext);
  const { advertisement } = useSelector((state) => state.widgetState);
  const { botAvatar, rasaServerUrl, userId } = appContext;
  return (
    <div className="flex space-x-1 ">
      <div className={`flex w-5 items-start`}>
        <img
          className={` ${showBotAvatar ? 'w-5' : 'hidden'}`}
          src={botAvatar}
          alt="Bot Logo"
        />
      </div>
      <div className="flex flex-col space-y-1">
        <div
          className={`mt-2 flex w-80 flex-wrap  gap-2 self-start whitespace-pre-line  break-words text-white`}
        >
          {buttons.map((item, idx) => (
            <Button
              key={idx}
              style={{
                whiteSpace: 'normal',
                height: 'auto'
              }}
              onClick={async (e) => {
                e.preventDefault();
                if (callback) {
                  if (item.type === 'openUrl') {
                    const { payload } = item;
                    dispatch(disableButtons(index));
                    dispatch(toggleUserTyping(true));
                    window.open(payload, '_blank');
                  } else {
                    const { title, payload } = item;
                    dispatch(disableButtons(index));
                    dispatch(addMessage(createUserMessage(title)));
                    dispatch(toggleBotTyping(true));
                    dispatch(toggleUserTyping(false));
                    dispatch(
                      fetchBotResponse({
                        rasaServerUrl,
                        message: payload,
                        sender: userId,
                        metadata: {}
                      })
                    );
                  }
                }
              }}
            >
              {item.title}
            </Button>
          ))}
        </div>
        {showBotAvatar && (
          <div className="text-[10px] italic  text-gray-500 antialiased">
            {formattedTs(ts)}
          </div>
        )}
      </div>
    </div>
  );
};
